const getById = (array, id) => {
  const [result] = array.filter(item => parseInt(item.id, 0) === parseInt(id, 0))
  return result
}

export default getById
